import React, {useEffect, useState} from 'react';
import TopNavbar from "../components/Navbar";
import {checkWritePermission} from "../functions/permissions";
import {useNavigate} from "react-router-dom";

function NoPage() {
    const navigate = useNavigate();

    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);


    useEffect(() => {
        checkWritePermission(navigate, setReadPermission, setWritePermission);
    }, []);


    return (
        <>
            <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>

            <div className='main'>
                <div className='header'>
                    <h2>404 Error</h2>
                </div>
                <p>Diese Seite existiert nicht</p>
            </div>
        </>
    );
}

export default NoPage;